export default __webpack_public_path__ + "static/media/icons-globe.ccfaeec6.svg";